import { Project } from "../types/project";
import wolfImage from "../assets/images/wolf-investment.png";
import vistaImage from "../assets/images/vista.png"
import hollaAmericanaImage from "../assets/images/holla-americana.png"
import marketMyndsImage from "../assets/images/market-mynds.png"
import fileNriImage from "../assets/images/file-nri.png"

const PROJECTS: Project[] = [
  {
    title: "Holla Americana",
    date: "12 / 2025",
    imgSrc: hollaAmericanaImage,
    speed: "-1.25",
    href: "https://www.hollaamericana.com",
    category: ["Travel Agency"]
  },
  {
    title: "Wolf Investment",
    date: "01 / 2023",
    imgSrc: wolfImage,
    speed: "1",
    href: "https://www.wolfinvestment.in",
    category: ["Investment Firm"]
  },
  {
    title: "Vista Journeys",
    date: "01 / 2023",
    imgSrc: vistaImage,
    speed: "-1.15",
    href: "https://www.vistajourneys.in",
    category: ["Travel Agency"]
  },
  
  {
    title: "Market Mynds",
    date: "01 / 2023",
    imgSrc: marketMyndsImage,
    speed: "1.5",
    href: "https://www.marketmynds.com",
    category: ["Financial Services"]
  },
  {
    title: "File NRI",
    date: "01 / 2023",
    imgSrc: fileNriImage,
    speed: "1.7",
    href: "https://www.filenri.com",
    category: ["Financial Services"]
  },
  // {
  //   title: "TTMM - UI/UX Case Study",
  //   date: "01 / 2023",
  //   imgSrc: "https://rdiant.netlify.app//images/projects/project3.webp",
  //   speed: "-2"
  // },
  // {
  //   title: "Fitness Gym Website",
  //   date: "01 / 2023",
  //   imgSrc: "https://rdiant.netlify.app//images/projects/project4.webp",
  //   speed: "0"
  // },
];

export default PROJECTS;